<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper without-bottom-cta">
    <div class="header-with-cta mb-24">
      <h3 class="title s-18">Add Treatment Phase</h3>
    </div>
    <form
      nz-form
      class="form"
      nzLayout="horizontal"
      [formGroup]="treatmentPhaseForm">
      <div class="form-grid">
        <nz-form-item>
          <nz-form-label nzFor="phaseLabel" nzRequired
            >Phase Label</nz-form-label
          >
          <nz-form-control [nzErrorTip]="labelErrorTpl">
            <input
              name="minutes"
              type="text"
              nz-input
              formControlName="labelNote"
              placeholder="Enter label" />
            <ng-template #labelErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter label.
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                label can not exceed 20 characters.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="phaseStartDate" nzRequired
            >Phase Start Date</nz-form-label
          >
          <nz-form-control [nzErrorTip]="dateErrorTpl">
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              nzPlaceHolder="Select Date"
              class="with-suffix"
              nzFormat="MM/dd/yyyy"
              formControlName="noteDate"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select Date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
            </ng-template>
            <ng-template #dateErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please select date.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="add-button-wrapper">
          <button
            nz-button
            type="button"
            nzType="primary"
            [disabled]="treatmentPhaseForm.invalid"
            (click)="onSubmit()">
            {{ isEditMode ? 'Save' : 'Add' }}
          </button>
        </nz-form-item>
      </div>
    </form>
    <div class="header-with-cta without-border">
      <h3 class="title s-18">Treatment Phases</h3>
    </div>
    <app-no-data
      *ngIf="(graphLabels$ | async)?.result?.length === 0"
      [title]="'No treatment phases '"
      [desc]="'No treatment phases found for this student'"
      [icon]="'/assets/icon/icon-line-chart-up.svg'">
    </app-no-data>
    <nz-table
      *ngIf="(graphLabels$ | async)?.result?.length !== 0"
      #sortTable
      [nzData]="(graphLabels$ | async)?.result ?? []"
      [nzSize]="'middle'"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '700px', y: 'calc(100vh - 527px)' }">
      <thead>
        <tr>
          <th scope="col" [nzSortFn]="true" [title]="listOfColumn[0].title">
            {{ listOfColumn[0].title }}
          </th>
          <th
            scope="col"
            [title]="listOfColumn[1].title"
            [nzColumnKey]="listOfColumn[1].key">
            {{ listOfColumn[1].title }}
          </th>
          <th scope="col" nzRight>{{ listOfColumn[2].title }}</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let data of sortTable.data; let i = index">
          <td [title]="data.labelNote">{{ data.labelNote }}</td>
          <td [title]="data.noteDate | userDate: 'MM/dd/yyyy'">
            {{ data.noteDate | userDate: 'MM/dd/yyyy' }}
          </td>
          <td nzRight>
            <div class="action-btn-wrapper">
              <button nz-button nzType="text" (click)="edit(data)">
                <svg-icon
                  [title]="'Edit Treatment Phase'"
                  src="/assets/icon/icon-edit.svg"
                  class="icon s-20"
                  aria-label="Edit"></svg-icon>
              </button>
              <button
                nz-button
                nzType="default"
                class="action-btn"
                (click)="showDeleteModal(data.id)">
                <svg-icon
                  [title]="'Delete Treatment Phase'"
                  src="/assets/icon/icon-trash.svg"
                  class="icon s-20"
                  aria-label="Trash"></svg-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <app-confirm-dialog
    [isVisible]="showConfirmDialog"
    [title]="'Delete Record'"
    message="Are you sure you want to remove this graph label?"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Delete'"
    [loading]="isDeleting"
    (confirmed)="removeRecord()"
    (cancelled)="handleCancel()"
    (closed)="handleCancel()">
  </app-confirm-dialog>
</nz-spin>
